<div *ngIf="auth.authenticated;else other_content;">
  <h2>New Users</h2>
  <br />

  <p *ngIf="!newUsers"><em>Loading...</em></p>
  <div class="search-user">
    <input class="form-control" type="text" name="search" [(ngModel)]="searchUser" autocomplete="off" placeholder="Search by User or Lookup Id" />
  </div>
  <table class='table' *ngIf="newUsers">
    <thead>
      <tr>
        <th>User</th>
        <th>View Accounts?</th>
        <th>View Numbers?</th>
        <th>View Replies?</th>
        <th>View DNC Entries?</th>
        <th>View Ref Exceptions?</th>
        <th>Flex Id</th>
        <th>Lookup Id</th>
        <th>Manager</th>

        <th></th>
      </tr>
    </thead>
    <tbody>

      <tr *ngFor="let applicationUser of newUsers | filter:searchUser ">
        <ng-container *ngIf="applicationUser">
          <td>
            {{ applicationUser.userId }}
          </td>

          <ng-container *ngIf="applicationUser.midStageAccountsAccess; else orange">
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-success active" [class.active]="applicationUser.midStageAccountsAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.midStageAccountsAccess" autocomplete="off"> {{ applicationUser.midStageAccountsAccess ? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-container>
          <ng-template #orange>
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-warning active" [class.active]="applicationUser.midStageAccountsAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.midStageAccountsAccess" autocomplete="off"> {{ applicationUser.midStageAccountsAccess ? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-template>

          <ng-container *ngIf="applicationUser.deactivatedNumbersAccess; else orange2">
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-success active" [class.active]="applicationUser.deactivatedNumbersAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.deactivatedNumbersAccess" autocomplete="off"> {{ applicationUser.deactivatedNumbersAccess ? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-container>
          <ng-template #orange2>
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-warning active" [class.active]="applicationUser.deactivatedNumbersAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.deactivatedNumbersAccess" autocomplete="off"> {{ applicationUser.deactivatedNumbersAccess ? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-template>

          <ng-container *ngIf="applicationUser.textRepliesAccess; else orange3">
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-success active" [class.active]="applicationUser.textRepliesAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.textRepliesAccess" autocomplete="off"> {{ applicationUser.textRepliesAccess? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-container>
          <ng-template #orange3>
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-warning active" [class.active]="applicationUser.textRepliesAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.textRepliesAccess" autocomplete="off"> {{ applicationUser.textRepliesAccess ? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-template>

          <ng-container *ngIf="applicationUser.agentDNCEntriesAccess; else orange5">
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-success active" [class.active]="applicationUser.agentDNCEntriesAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.agentDNCEntriesAccess" autocomplete="off"> {{ applicationUser.agentDNCEntriesAccess ? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-container>
          <ng-template #orange5>
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-warning active" [class.active]="applicationUser.agentDNCEntriesAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.agentDNCEntriesAccess" autocomplete="off"> {{ applicationUser.agentDNCEntriesAccess ? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-template>

          <ng-container *ngIf="applicationUser.referenceAutomationExceptionsAccess; else orange4">
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-success active" [class.active]="applicationUser.referenceAutomationExceptionsAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.referenceAutomationExceptionsAccess" autocomplete="off"> {{ applicationUser.referenceAutomationExceptionsAccess? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-container>
          <ng-template #orange4>
            <td>
              <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-warning active" [class.active]="applicationUser.referenceAutomationExceptionsAccess">
                  <input type="checkbox" [(ngModel)]="applicationUser.referenceAutomationExceptionsAccess" autocomplete="off"> {{ applicationUser.referenceAutomationExceptionsAccess ? 'Yes' : 'No' }}
                </label>
              </div>
            </td>
          </ng-template>


          <td>
            <div class="input-group input-group-lg">
              <input class="input-group-text" [(ngModel)]="applicationUser.fiservUserId" placeholder="Fiserv User Id">
            </div>
          </td>
          <td>
            <div class="input-group input-group-lg">
              <input class="input-group-text" [(ngModel)]="applicationUser.lookupUserId" placeholder="Lookup User Id">
            </div>
          </td>
          <td>
            <div class="btn-group-toggle" data-toggle="buttons">
              <label class="btn btn-primary active" [class.active]="applicationUser.isUserManager">
                <input type="checkbox" [(ngModel)]="applicationUser.isUserManager" autocomplete="off"> {{ applicationUser.isUserManager ? 'Yes' : 'No' }}
              </label>
            </div>
          </td>
          <td>
            <div class="btn-group-vertical">
              <button type="button" class="btn btn-primary" (click)='saveUser(applicationUser)'>Save</button>
              <button type="button" class="btn btn-danger" (click)='deleteUser(applicationUser)'>Delete</button>
          </div>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #other_content>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />

  <div class="user">
    <h1>Please <a (click)="auth.signIn()" [routerLink]="">sign in</a> to continue.</h1>
  </div>

  <br />
  <br />
  <br />
  <br />

  <div class="user">
    <img class="logo" src="assets/CollectorAssistantToolLogoNavy.png" />
  </div>

</ng-template>



// WEBPACK FOOTER //
// ./src/app/user-manager/new-users/new-users.component.html